import React from "react";

const posts = [
  {
    claps: 267,
    title: "Flutter 3 — ThemeData finally Extendeddd…",
    excerpt: "A deep dive into Flutter 3's extended ThemeData — how to cleanly add custom theme properties and access them anywhere in your widget tree.",
    url: "https://medium.com/@lakshay-parnami/flutter-3-themedata-finally-extendeddd-aa0069cc9996",
  },
  {
    claps: 123,
    title: "Flutter: Animated AppBar! Part — 3",
    excerpt: "The final part of the Animated AppBar series — polishing animations, handling edge cases, and shipping a production-ready custom app bar in Flutter.",
    url: "https://medium.com/p/6583aabcbec0",
  },
  {
    claps: 53,
    title: "Handling Permissions in Flutter with Delegation Pattern",
    excerpt: "A clean architecture approach to permission handling in Flutter — keeping your UI layer free of boilerplate with the delegation pattern.",
    url: "https://medium.com/@lakshay-parnami/handling-permissions-in-flutter-with-delegation-pattern-eb8a9d3a442a",
  },
  {
    claps: 52,
    title: "Design Patterns in Kotlin — Part 1",
    excerpt: "Exploring classic design patterns through a Kotlin lens — cleaner syntax, more expressive code, and real-world examples.",
    url: "https://medium.com/@lakshay-parnami/design-patterns-in-kotlin-part-1-9332d51f99f",
  },
];

const ThumbsUpIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="13" height="13" aria-hidden="true">
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z" />
    <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m9 18 6-6-6-6" />
  </svg>
);

const BlogAnimation = () => {
  return (
    <section className="d2-blog" id="blog" aria-labelledby="blog-title">
      <div className="d2-container">
        <div className="d2-blog-header">
          <div>
            <span className="section-label reveal">Writing</span>
            <h2 className="section-title reveal reveal-delay-1" id="blog-title">From the Blog</h2>
            <p className="section-desc reveal reveal-delay-2">Thoughts on Android, Flutter, Kotlin, and shipping great mobile products.</p>
          </div>
          <a href="https://lakshay-parnami.medium.com/" target="_blank" rel="noopener noreferrer" className="btn-secondary reveal reveal-delay-2">
            View all on Medium
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M7 17 17 7M7 7h10v10" />
            </svg>
          </a>
        </div>

        <div className="d2-blog-grid">
          {posts.map((post, i) => (
            <a
              key={post.url}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`blog-card reveal${i > 0 ? ` reveal-delay-${Math.min(i, 4)}` : ""}`}
            >
              <h3 className="blog-title">{post.title}</h3>
              <p className="blog-excerpt">{post.excerpt}</p>
              <div className="blog-card-footer">
                <span className="blog-arrow">Read on Medium <ArrowIcon /></span>
                <span className="blog-claps"><ThumbsUpIcon />{post.claps}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogAnimation;
